import request from "@/utils/request";

export function login(data) {
  return request({
    url: "api/auth/authenticate",
    method: "post",
    params: {
      username: data.username,
      timestamp: data.timestamp,
      sign: data.sign,
    },
  })
};


// WEBPACK FOOTER //
// ./src/api/user.js